import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import { Deserializer } from 'jsonapi-serializer';

import getFileName from 'utils/getFileName';
import ArModels from 'api/resources/arModels';
import { processErrorByAlert } from 'utils/getErrors';

import PrimaryButton from 'styled/Buttons/PrimaryButton';
import SecondaryButton from 'styled/Buttons/SecondaryButton';

import Footer from 'components/ConfirmModal/Footer';
import Content from 'components/ConfirmModal/Content';
import ModalTitle from 'components/ConfirmModal/Title';
import ConfirmModal from 'components/ConfirmModal';

import ARFormElements from 'admin-editor/components/ARFormElements';

class EditArModel extends React.PureComponent {
  state = {
    loading: false,
    title: '',
    cover: undefined,
    IOSModel: undefined,
    AndroidModel: undefined,
    isShowInFeed: false,
  }

  componentDidMount() {
    this.loadModel();
  }

  handleCheckboxChange = ({ target }) => {
    this.setState({ isShowInFeed: target.checked });
  }

  handleTitleChange = ({ target }) => {
    this.setState({ title: target.value });
  }

  handleCoverLoad = (file) => {
    this.setState({
      cover: {
        filename: getFileName({
          url: file.attributes.path,
          type: '/ar',
        }),
        file_type: file.attributes.content_type,
        file_size: file.attributes.size,
        width: file.attributes.width,
        height: file.attributes.height,
        medialib_item_id: file.id,
      },
    });
  }

  handleIOSModelLoad = (file) => {
    this.setState({
      IOSModel: {
        filename: getFileName({
          url: file.attributes.path,
          type: '/ar',
        }),
        file_type: file.attributes.content_type,
        file_size: file.attributes.size,
        url: file.attributes.path,
        medialib_item_id: file.id,
      },
    });
  }

  handleAndroidModelLoad = (file) => {
    this.setState({
      AndroidModel: {
        filename: getFileName({
          url: file.attributes.path,
          type: '/ar',
        }),
        file_type: file.attributes.content_type,
        file_size: file.attributes.size,
        url: file.attributes.path,
        medialib_item_id: file.id,
      },
    });
  }

  loadModel = async () => {
    this.setState({ loading: true });

    try {
      const response = await ArModels.get({
        modelId: this.props.id,
        include: 'cover,android_file,ios_file',
      });

      const model = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.setState({
        title: model.title,
        isShowInFeed: model.isActive,
        cover: model.cover && {
          filename: model.cover.filename,
          file_type: model.cover.fileType,
          file_size: model.cover.fileSize,
          width: model.cover.width,
          height: model.cover.height,
          medialib_item_id: model.cover.medialibItemId,
        },
        IOSModel: model.iosFile && {
          filename: model.iosFile.filename,
          file_type: model.iosFile.fileType,
          file_size: model.iosFile.fileSize,
          url: model.iosFile.path,
          medialib_item_id: model.iosFile.medialibItemId,
        },
        AndroidModel: model.androidFile && {
          filename: model.androidFile.filename,
          file_type: model.androidFile.fileType,
          file_size: model.androidFile.fileSize,
          url: model.androidFile.path,
          medialib_item_id: model.androidFile.medialibItemId,
        },
        loading: false,
      });
    } catch (err) {
      this.setState({ loading: false });
      processErrorByAlert(err);
      this.props.onClose();
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    try {
      const response = await ArModels.patch({
        modelId: this.props.id,
        body: {
          data: {
            type: 'augmented_reality_model',
            attributes: {
              title: this.state.title,
              is_active: this.state.isShowInFeed,
            },
            relationships: {
              cover: {
                data: {
                  type: 'image',
                  attributes: this.state.cover,
                },
              },
              android_file: {
                data: {
                  type: 'augmented_reality_file',
                  attributes: this.state.AndroidModel,
                },
              },
              ios_file: {
                data: {
                  type: 'augmented_reality_file',
                  attributes: this.state.IOSModel,
                },
              },
            },
          },
        },
        include: 'cover',
      });

      const model = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      Alert.success('Модель успешно изменена');
      this.props.onUpdate(model);
      this.props.onClose();
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });
    }
  }

  handleDeleteClick = async () => {
    this.setState({ loading: true });

    try {
      await ArModels.delete({ modelId: this.props.id });

      Alert.success('Модель успешно удалена');
      this.props.onDelete({ id: this.props.id });
      this.props.onClose();
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <ConfirmModal onClose={this.props.onClose} isOpen>
        <form onSubmit={this.handleSubmit}>
          <Content style={{ fontSize: '14px' }}>
            <ModalTitle style={{ marginBottom: '16px' }}>Редактирование</ModalTitle>

            <ARFormElements
              checkboxId="showInFeedEdit"
              title={this.state.title}
              cover={this.state.cover}
              IOSModel={this.state.IOSModel}
              AndroidModel={this.state.AndroidModel}
              isShowInFeed={this.state.isShowInFeed}
              onIOSModelLoad={this.handleIOSModelLoad}
              onAndroidModelLoad={this.handleAndroidModelLoad}
              onCoverLoad={this.handleCoverLoad}
              onTitleChange={this.handleTitleChange}
              onCheckboxChange={this.handleCheckboxChange}
            />
          </Content>

          <Footer style={{ marginBottom: '40px' }}>
            <PrimaryButton
              type="submit"
              style={{ width: '121px', marginRight: '16px' }}
              disabled={this.state.loading}
            >
              применить
            </PrimaryButton>

            <SecondaryButton
              type="button"
              style={{ marginRight: '16px' }}
              onClick={this.handleDeleteClick}
              disabled={this.state.loading}
            >
              удалить
            </SecondaryButton>

            <SecondaryButton
              type="button"
              onClick={this.props.onClose}
              disabled={this.state.loading}
            >
              отмена
            </SecondaryButton>
          </Footer>
        </form>
      </ConfirmModal>
    );
  }
}

EditArModel.propTypes = {
  id: PropTypes.string.isRequired,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  onClose: PropTypes.func,
};

EditArModel.defaultProps = {
  onUpdate: () => {},
  onDelete: () => {},
  onClose: () => {},
};

export default EditArModel;
